import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Loader, URLS, useAuth0 } from '@livingsecurity/shared';
import { isStepUpAllowed, isSteppedUp } from '../../utils/authUtils';

const EnterStepUp = () => {
  const history = useHistory();
  const { user } = useAuth0();

  useEffect(() => {
    const enterStepUp = () => {
      if (isStepUpAllowed(user) && isSteppedUp(user)) {
        localStorage.setItem("STEPPED_UP", 'true');
        console.log("User is stepped up ls-admin, setting STEPPED_UP flag and redirecting to companies");
        history.push(URLS.companies);
        return;
      }

      console.warn("User is not allowed or not authenticated as ls-admin");
      history.push('/');
    };

    enterStepUp();
  }, [history, user]);

  return <Loader />;
};

export default EnterStepUp;
